/* unplugin-vue-components disabled */import { render } from "./exam-Mock.vue?vue&type=template&id=1223cf58&scoped=true"
import script from "./exam-Mock.vue?vue&type=script&lang=js"
export * from "./exam-Mock.vue?vue&type=script&lang=js"

import "./exam-Mock.vue?vue&type=style&index=0&id=1223cf58&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1223cf58"]])

export default __exports__